import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'app-list-product-reports',
  imports: [CardModule, ButtonModule, CommonModule],
  templateUrl: './list-sale-reports.component.html'
})
export class ListSaleReportsComponent {


  constructor(private router: Router){}

  reports= [
    {
      label: 'Itens mais Vendidos', 
      description: 'Relatório que lista os itens mais vendidos por período',
      link: 'app/reports/sales/best-selling'
    },
     {
      label: 'Itens Menos Vendidos',
      description: 'Relatório que lista os itens menos vendidos por período.',
      link: 'app/reports/sales/least-selling'
    },
    {
      label: 'Clientes que mais Compram',
      description: 'Relatório que lista os clientes que mais compram por período.',
      link: 'app/reports/sales/best-customers'
    }
  ];


  goTo(link: string){
    
    if(link === 'app/reports/sales/best-selling'){
      this.router.navigate([link], {
        queryParams: { type: 'BEST_SELLING'}
      });
    }else if(link === 'app/reports/sales/least-selling'){
      this.router.navigate([link], {
        queryParams: { type: 'LEAST_SOLD' }
      });
    }
    else {
      this.router.navigate([link]);
    }
  }
  
}
